import { useCallback, useMemo } from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

import { ContextNavigate } from '../../shared/components/context-navigate/context-navigate';
import { useDesktop } from '../../shared/hooks/breakpoint';
import { useContextNavigate } from '../../shared/hooks/use-context-navigate';
import { GameModeSelection } from '../components/game-mode-selection/game-mode-selection';
import { Gameplay } from '../containers/gameplay/gameplay';
import { GameplayLayout } from '../layout/gameplay.layout';

export function GameplayRoute() {
    const { slug } = useParams();
    const [params] = useSearchParams();
    const realmoney = params.get('realmoney');
    const auth = useAuth();
    const navigate = useContextNavigate();
    const isDesktop = useDesktop();
    const location = useLocation();

    const onSlugsChange = useCallback(
        (slugs: Array<string | undefined>) => {
            navigate(`/gameplay/${slugs.map((slug) => slug || '').join(',')}${location.search}`);
        },
        [navigate, location],
    );
    const onClose = useCallback(() => {
        navigate('/');
    }, [navigate]);

    const isUserLoggedIn = auth.isAuthenticated && auth?.user;
    const shouldShowModeSelection = !isDesktop && realmoney === null && !isUserLoggedIn;
    const slugs = useMemo(() => slug?.split(',') ?? [], [slug]);

    if (!slug) {
        return <ContextNavigate to="/lobby" />;
    }

    return (
        <GameplayLayout
            slugs={slug.split(',')}
            onClose={onClose}
            frameArea={
                shouldShowModeSelection ? (
                    <GameModeSelection slugs={slugs} />
                ) : (
                    <Gameplay onSlugsChange={onSlugsChange} onClose={onClose} slugs={slugs} />
                )
            }
        />
    );
}
